module.exports = __webpack_public_path__ + "img/sponsorenwand.0e12c162.jpg";